import { FlagComponent as CountryFlag } from '@cmg/common';
import { Stack, Typography } from '@cmg/design-system';
import defaultTo from 'lodash/defaultTo';
import React from 'react';

import type {
  CalendarGridCustomCellRendererProps,
  CalendarGridRowData,
} from '../../CalendarGrid.model';

export type Value = CalendarGridRowData['exchangeCountry'];

export type ExchangeCountryCellRendererProps = CalendarGridCustomCellRendererProps<Value>;

export const ExchangeCountryCellRenderer: React.FC<ExchangeCountryCellRendererProps> = ({
  valueFormatted,
  value,
}) => {
  if (!value) {
    return <React.Fragment>{valueFormatted}</React.Fragment>;
  }

  return (
    <Stack flexDirection="row" gap={1} alignItems="center">
      <CountryFlag countryCode={value} countryDisplayName={defaultTo(valueFormatted, '')} />
      <Typography
        variant="body2"
        component="span"
        lineHeight="inherit"
        textOverflow="ellipsis"
        overflow="hidden"
      >
        {valueFormatted}
      </Typography>
    </Stack>
  );
};
